export const DAMAGE = {
  NO_ISSUES: 'No issues found',
  ADDITIONAL_DAMAGE: 'Additional damage found',
};
